export const LOCAL_STORAGE_KEYS = {
  MENU_PORTFOLIO: "portfolio-menu-wide",
  MENU_PROJECT: "project-menu-wide",
  RECENT_PROJECT: "most-recent-project",
  ADMIN_NOTIFICATION_FILTERS: "admin-notification-filters",
  LAST_USED_EMAIL: "last-used-email",
  PORTFOLIO_VIEW_MODE: "portfolio-view",
  TICKET_DESCENDING_ACTIVITIES: "ticket-descending-activities",
  USER_SELECTED_LANGUAGE: "language", // Currently selected language (in sync with BE)
};
